import { Anskaffningsformer } from "~app/common/models/constants";
import { ValidationContext } from "../../../common/validation/validationContext";
import { ValidationErrorLevels } from "../../../common/validation/ValidationErrorLevels";
import { ValidationScopes } from "../../../common/validation/ValidationScopes";
import { SkapaArbetsorderData } from "./models/SkapaArbetsorderData";

export class SkapaArbetsorderValidation {
    static init(
        skapaArbetsorderModel: SkapaArbetsorderData
    ): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.skapa).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text: "Du måste ange ett namn" },
                model: () => skapaArbetsorderModel.namn,
                name: "arbetsorderNamn",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 2,
                message: { text: "Du måste ange hämtplats" },
                model: () => skapaArbetsorderModel.hamtplatsId,
                name: "hamtplatsId",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 3,
                message: { text: "Du måste ange anskaffningsform" },
                model: () => skapaArbetsorderModel.anskaffningsForm,
                name: "anskaffningsForm",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 4,
                message: { text: "Du måste ange lagerplats" },
                model: () => skapaArbetsorderModel.lagerplatsId,
                name: "lagerplats",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 5,
                message: { text: "Du måste ange lagerplats för avångshamn" },
                model: () => skapaArbetsorderModel.avgangshamnId,
                expression: () => !!skapaArbetsorderModel.avgangshamnId,
                applicable: () => skapaArbetsorderModel.avgangsmatning,
                name: "avgangshamn"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 6,
                message: { text: "Du måste ange kund för avgångsmätning" },
                model: () => skapaArbetsorderModel.kundId,
                expression: () => !!skapaArbetsorderModel.kundId,
                applicable: () => skapaArbetsorderModel.avgangsmatning,
                name: "kund"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 7,
                message: { text: "Du måste ange leverantör för avgångsmätning" },
                model: () => skapaArbetsorderModel.ckleverantorId,
                name: "leverantor",
                applicable: () => skapaArbetsorderModel.avgangsmatning && skapaArbetsorderModel.anskaffningsForm === Anskaffningsformer.Import,
                expression: () => !!skapaArbetsorderModel.ckleverantorId
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 8,
                message: { text: "Du måste ange avgångsmätning ja/nej" },
                model: () => skapaArbetsorderModel.avgangsmatning,
                name: "avgangsmatning",
                applicable: () => skapaArbetsorderModel.anskaffningsForm === Anskaffningsformer.Import,
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 9,
                message: { text: "BåtId måste vara i format: IDXXXX där X är siffror" },
                model: () => skapaArbetsorderModel.batId,
                name: "batId",
                applicable: () => skapaArbetsorderModel.transportslag === "Sjötransport",
                expression: () => {
                    const batId = skapaArbetsorderModel.batId;
                    if (!batId || batId.length === 0) {
                        return true;
                    }
                    if (batId.length !== 6 && batId.length > 0) {
                        return false;
                    }

                    const regex = /^ID\d{4}$/;
                    return regex.test(batId);
                }
            }
        ]);
        return context;
    }
}
